<template>
  <div class="industry-wrap">
    <div class="w">
      <divider chinese="行业数据" english="MOST CURRENT INFORMATION"/>
      <ul class="tab-wrap">
        <li
          :class="['tab-item', { 'active': isActive === item.id }]"
          v-for="item in tabs"
          :key="item.id"
          @click="handleTabsChange(item)"
        >
          {{ item.blockName }}
        </li>
      </ul>
      <div class="tab-con w">
        <div
          v-for="item in blockContents"
          :key="item.id"
          @click="handleCardClick(item.id)"
        >
          <el-card class="tab-con-list">
            <div slot="header" class="tab-con-header">
              <span class="title" :title="item.contentTitle">{{ item.contentTitle }}</span>
              <span class="timer">{{ item.publishTime }}</span>
            </div>
            <p>{{ item.content }}</p>
          </el-card>
        </div>
      </div>
      <div class="more" @click="handleMoreClick(isActive)">
        <i class="el-icon-d-arrow-left"></i>
      </div>
    </div>
  </div>
</template>

<script>
import IndexDivider from '../IndexDivider.vue'
import http from '@/http/index'

export default {
  name: 'IndustryInfo',
  data () {
    return {
      tabs: [],
      blockContents: [],
      isActive: null, // 初始化为 null 更安全
      blockName: ''
    }
  },
  async created () {
    const params = { level: '1' }
    await this.getBlockNames(params)
  },
  methods: {
    handleMoreClick (id) {
      if (id == null) return
      this.$store.state.isActive = 'newActive'
      this.$router.push({
        name: 'NewsPage',
        params: { blockId: id }
      })
    },
    handleCardClick (id) {
      if (id == null) return
      this.$store.state.isActive = 'newActive'
      this.$router.push({
        name: 'NewsDetail',
        params: {
          id,
          blockName: this.blockName
        }
      })
    },
    handleTabsChange (item) {
      this.isActive = item.id
      this.blockContents = item.blockContents || []
      this.blockName = item.blockName || ''
    },
    async getBlockNames (params) {
      try {
        const res = await http.getBlockNames(params)
        const dataList = res?.data?.data

        if (!Array.isArray(dataList) || dataList.length < 2) {
          console.warn('getBlockNames: response data is not valid array or too short', res)
          return
        }

        const secondItem = dataList[1]
        if (!secondItem || !secondItem.id) {
          console.warn('Second block item missing or has no id:', secondItem)
          return
        }

        await this.getTabsInfo(secondItem.id)
      } catch (error) {
        console.error('Failed to fetch block names:', error)
      }
    },
    async getTabsInfo (id) {
      if (!id) {
        console.warn('getTabsInfo called with invalid id:', id)
        return
      }

      try {
        const res = await http.acquireFirstPortalTitleList({ blockType: id })
        const data = res?.data?.data

        if (!Array.isArray(data) || data.length === 0) {
          console.warn('No tab data received from acquireFirstPortalTitleList')
          this.tabs = []
          this.blockContents = []
          return
        }

        this.tabs = data
        const firstTab = data[0]
        this.isActive = firstTab.id
        this.blockContents = firstTab.blockContents || []
        this.blockName = firstTab.blockName || ''
      } catch (error) {
        console.error('Failed to fetch tabs info:', error)
        this.tabs = []
        this.blockContents = []
      }
    }
  },
  components: {
    divider: IndexDivider
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/sass/variable.scss';

.industry-wrap {
  width: 100%;
  height: 602px;
  background: url("../../assets/images/databg.png") no-repeat;
  background-size: cover;
  position: relative;

  .w {
    width: $el-center;
    margin: 0 auto;

    .tab-wrap {
      display: flex;
      justify-content: center;
      margin: 40px 0;

      .tab-item {
        width: 120px;
        height: 38px;
        background: #fff;
        border-radius: 2px;
        text-align: center;
        line-height: 38px;
        color: $el-main-color;
        cursor: pointer;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

        &.active {
          color: #fff;
          background: $el-main-color;
        }
      }
    }

    .tab-con {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .tab-con-list {
        width: 380px;
        height: 185px;
        background: #fff;
        margin-bottom: 27px;
        cursor: pointer;

        .tab-con-header {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .title {
            color: $el-main-color;
            font-size: 18px;
            width: 200px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .timer {
            font-size: 12px;
            color: #999999;
          }
        }

        p {
          height: 75px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          color: #7b7b83;
          line-height: 24px;
        }
      }
    }

    .more {
      width: 60px;
      height: 60px;
      background: #fff;
      border-radius: 50%;
      text-align: center;
      line-height: 60px;
      color: #999;
      font-size: 30px;
      transform: rotate(-90deg);
      margin: -31px auto 0;
      cursor: pointer;

      .el-icon-d-arrow-left {
        transform: translate3d(-10px, 0, 0);
        animation: move 1s ease-in-out infinite alternate;
      }

      &:hover .el-icon-d-arrow-left {
        color: $el-main-color;
      }
    }
  }
}

@keyframes move {
  0% {
    transform: translate3d(-5px, 0, 0);
  }
  100% {
    transform: translate3d(-10px, 0, 0);
  }
}
</style>
